export default __webpack_public_path__ + "static/media/reportar-incidente.0f7f0112.svg";